import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "HazardListPage" */
	'pages/intervention/Hazard/HazardListPage'));

export default [{ component, exact: true, path: '/hazards' }];